import LabelsConnected from './LabelsConnected'
export default LabelsConnected
